const ASSET_CLASS_NAMES = require('../../constants');
const flow = require('lodash/fp/flow');
const map = require('lodash/fp/map');
const reduce = require('lodash/fp/reduce');
const find = require('lodash/fp/find');
const sortBy = require('lodash/fp/sortBy');
const last = require('lodash/fp/last');
const flatten = require('lodash/fp/flatten');
const filter = require('lodash/fp/filter');
const lget = require('lodash/get');
const sumBy = require('lodash/sumBy');
const merge = require('lodash/merge');
const memoizer = require('../request-handler/utils/memoizer');

const { getMonth, getYear } = require('date-fns');

const OTHER_PERIOD_TYPE = {
  '30 Days': {
    periodType: 'days',
    periodNo: 30,
  },
  '12 Months': {
    periodType: 'months',
    periodNo: 12,
  },
};

function parseMaturity(item) {
  if (!item) return null;

  const filterPeriod = filter(period => {
    return Object.keys(OTHER_PERIOD_TYPE).indexOf(period.matPeriod) >= 0;
  });

  return {
    aggregate: map(parseMaturityAggregate, item.matAggregate),
    count: flow(
      filterPeriod,
      map(parseMaturityCount)
    )(item.matCount),
    details: map(parseMaturityDetails, item.matDetails),
  };
}

function parseMaturityAggregate(item) {
  if (!item) return null;

  return {
    id: ASSET_CLASS_NAMES[item.matAstGrpCd],
    name: item.matAstName,
    maturityInvCtg: item.matInvCtg,
    maturityCount: item.matCount,
    maturityValue: item.matAmtAggRefCcy,
    maturityYear: item.matYear,
    maturityMonth: item.matMth,
  };
}

function parseMaturityCount(item) {
  if (!item) return null;

  return {
    maturityCount: item.totalMat,
    period: item.matPeriod,
    periodType: lget(OTHER_PERIOD_TYPE, `${item.matPeriod}.periodType`),
    periodNo: lget(OTHER_PERIOD_TYPE, `${item.matPeriod}.periodNo`),
  };
}

function parseMaturityDetails(item) {
  if (!item) return null;

  return merge({
    id: item.matPosId,
    name: item.matDesc,
    assetId: ASSET_CLASS_NAMES[item.matAstGrpCd],
    assetName: item.matAstName,
    maturityDate: item.matMtrDte,
    maturityInvCtg: item.matInvCtg,
    maturityValue: item.matAmtRefCcy,
    maturityPFID: item.matPfId,
  }, parseMaturityDetailsAdditional(item));
}

function parseMaturityDetailsAdditional(item) {
  if (!item) return null;

  let parsed = {
      isin: item.matIsin,
      maturityPandIPosCcy: item.matAmtPosCcy,
      maturityPandIPosCcyUnit: item.matCcy,
      quantity: item.matQty,
  };
  return parsed;
  // const assetId = ASSET_CLASS_NAMES[item.matAstGrpCd];
  // switch (assetId) {
  //   case 'bonds':
  //     parsed = {
  //       isin: item.matIsin,
  //       maturityPandIPosCcy: item.matAmtPosCcy,
  //       maturityPandIPosCcyUnit: item.matCcy,
  //       quantity: item.matQty,
  //     };
  //     break;

  //   case 'loans':
  //     parsed = {
  //       maturityPandIPosCcy: item.matAmtPosCcy,
  //       maturityPandIPosCcyUnit: item.matCcy,
  //       maturityInterestPosCcy: item.matIntRate,
  //       maturityInterestPosCcyUnit: item.matCcy,
  //     };
  //     break;

  //   case 'mmInstruments':
  //     parsed = {
  //       maturityPandIPosCcy: item.matAmtPosCcy,
  //       maturityPandIPosCcyUnit: item.matCcy,
  //       maturityInterestPosCcy: item.matIntRate,
  //       maturityInterestPosCcyUnit: item.matCcy,
  //     };
  //     break;

  //   case 'optionsDerivatives':
  //     parsed = {
  //       maturityValuePrimary: item.matMatPrmCcy,
  //       maturityValuePrimaryUnit: item.matPrmCcy,
  //       maturityValueAlternate: item.matMatAltCcy,
  //       maturityValueAlternateUnit: item.matAltCcy,
  //       dciFixingDate: item.matNextFixingDt,
  //     };
  //     break;
  // }
  
}

function parseMaturityInNextOneYear(item) {
  if (!item) return null;
  return item.matMtrDte;
}

function serviceFactory({ api }) {
  const getMaturitiesPromises = (metaData, portfolioId, fromDate, toDate) => {
    const bonds = api.getChMaturityDetails(metaData, portfolioId, fromDate, toDate)
      .then(map(parseMaturity));
    return bonds;
  }

  const getMaturityAssets = memoizer()((metaData, portfolioId, fromDate, toDate) => 
    getMaturitiesPromises(metaData, portfolioId, fromDate, toDate).then(data => {
      if (!data) return null;

      const details = flow(
        map(item => item && item.details),
        flatten,
        sortBy('maturityDate')
      )(data);

      const setGrouping = reduce((acc, item) => {
        if (item) {
          item = merge(item, {
            hasGrouping: item.maturityYear !== null && item.maturityMonth !== null,
            groupLabel: '',
            groupEnding: false,
          });

          if (item.hasGrouping) {
            const found = find({ maturityYear: item.maturityYear, maturityMonth: item.maturityMonth }, acc);
            item.groupLabel = (!found ? `${item.maturityYear}-${item.maturityMonth}` : null);

            const prev = last(acc);
            if (prev) prev.groupEnding = !found;

            item.details = JSON.stringify(
              details.filter(dtl => 
                dtl.maturityInvCtg == item.maturityInvCtg && 
                getMonth(dtl.maturityDate) + 1 == item.maturityMonth && 
                getYear(dtl.maturityDate) == item.maturityYear)
            );

          } else {
            item.details = JSON.stringify(
              details.filter(dtl =>
                dtl.maturityInvCtg == item.maturityInvCtg)
            );
          }
        
          acc.push(item);
        }
        return acc;
      }, []);

      return flow(
        map(item => item && item.aggregate),
        flatten,
        sortBy(['maturityYear', 'maturityMonth']),
        setGrouping
      )(data);
    }));

  const getMaturityOtherPeriodAssets = memoizer()((metaData, portfolioId, fromDate, toDate) =>
    getMaturitiesPromises(metaData, portfolioId, fromDate, toDate).then(data => {
      if (!data) return null;

      const countResult = flow(
        map(item => item && item.count),
        flatten
      )(data);

      const result = [];
      Object.keys(OTHER_PERIOD_TYPE).map(periodKey => {
        const period = OTHER_PERIOD_TYPE[periodKey];
        const filtered = countResult.filter(item => item && item.period === periodKey);
        const total = sumBy(filtered, 'maturityCount');

        if (total > 0) {
          result.push(merge(period, {
            period: periodKey,
            maturityCount: total,
          })); 
        }
      });

      return result;
    }));

  const getMaturityInNextOneYear = memoizer()((metaData, portfolioId) =>
    api.getMaturityInNextOneYear(metaData, portfolioId)
      .then(map(parseMaturityInNextOneYear)));

  return { getMaturityAssets, getMaturityOtherPeriodAssets, getMaturityInNextOneYear };
}

module.exports = serviceFactory;
